import { Icon } from '@plone/volto/components';
import paintBucketSVG from '@plone/volto/icons/paint.svg';
import heroSVG from '@plone/volto/icons/hero.svg';
import cardsSVG from '@plone/volto/icons/cards.svg';
import iconSVG from '@plone/volto/icons/select-all.svg';
import sliderSVG from '@plone/volto/icons/slider.svg';
import calendarSVG from '@plone/volto/icons/calendar.svg';
import { Edit as CustomHeroEdit, View as CustomHeroView} from './components/Blocks/CustomHero';
import { Edit as ButtonRowEdit, View as ButtonRowView} from './components/Blocks/ButtonRow';
import { Edit as MultiCardEdit, View as MultiCardView } from './components/Blocks/MultiCardBlock';
import { Edit as IconLinkRowEdit, View as IconLinkRowView} from './components/Blocks/IconLinkRow';
import { Edit as EmblaCarouselEdit, View as EmblaCarouselView} from './components/Blocks/EmblaCarousel';
import { Edit as EventsEdit, View as EventsView } from './components/Blocks/Events';
import { initForceLinksToBlank } from './forceLinksToBlank';
import { buildRestriction } from './config/blockRestrictions';
import blockThemes from './config/blockThemes';
import { injectEditThemeStyles } from './utils/injectEditThemeStyles';

const applyConfig = (config) => {
  config.settings.isMultilingual = false;
  config.settings.supportedLanguages = ['en'];
  config.settings.defaultLanguage = 'en';

  config.blocks.themes = blockThemes;

  if (typeof window !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => injectEditThemeStyles(blockThemes),
        { once: true },
      );
    } else {
      injectEditThemeStyles(blockThemes);
    }
  }

  //CustomHero
  config.blocks.blocksConfig.customHero = {
    id: 'customHero',
    title: 'Hero Block',
    icon: heroSVG,
    group: 'common',
    view: CustomHeroView,
    edit: CustomHeroEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  //ButtonRow
  config.blocks.blocksConfig.buttonRow = {
    id: 'buttonRow',
    title: 'Button Row',
    icon: cardsSVG,
    group: 'common',
    view: ButtonRowView,
    edit: ButtonRowEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  //IconLinkRow
  config.blocks.blocksConfig.iconLinkRow = {
    id: 'iconLinkRow',
    title: 'Icon Link Row',
    icon: iconSVG,
    group: 'common',
    view: IconLinkRowView,
    edit: IconLinkRowEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
    // Custom carousel settings
    carousel: {
      autoplay: true,   // default behaviour
      delay: 8000,      // milliseconds
    },
  };

  //Multicard Block
  config.blocks.blocksConfig.multiCard = {
    id: 'multiCard',
    title: 'Multi Card',
    icon: cardsSVG,
    group: 'common',
    view: MultiCardView,
    edit: MultiCardEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  //Embla Carousel
  config.blocks.blocksConfig.EmblaCarousel = {
    id: 'EmblaCarousel',
    title: 'Embla Carousel',
    icon: sliderSVG,
    group: 'common',
    view: EmblaCarouselView,
    edit: EmblaCarouselEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  //Events block for listing and carousel
  config.blocks.blocksConfig.Events = {
    id: 'Events',
    title: 'Events',
    icon: calendarSVG,
    group: 'common',
    view: EventsView,
    edit: EventsEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  //Configure which blocks show and for which Editors (Keep last in line, after block registrations)
  const blocksConfig = config.blocks.blocksConfig;
  Object.keys(blocksConfig).forEach((blockId) => {
    const originalRestricted = blocksConfig[blockId].restricted;
    blocksConfig[blockId] = {
      ...blocksConfig[blockId],
      restricted: buildRestriction(blockId, originalRestricted),
    };
  });

  return config;
};

if (typeof window !== 'undefined') {
  initForceLinksToBlank([
    '/events-results/results',
    '/about/governance/ssa-constitution.pdf',
    '/about/governance/ssa-bye-laws.pdf',
    '/about/governance/ssa-safeguarding-policy.pdf',
    // add more paths here
  ]);
}

export default applyConfig;
